module.exports = __webpack_public_path__ + "img/na-pali-coast.97f4f581.jpg";